module.exports = __webpack_public_path__ + "img/file-icon.svg";